import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import { connectRoutes } from 'redux-first-router';
import reduxThunk from 'redux-thunk';
import { persistCombineReducers, persistStore, persistReducer, createMigrate } from 'redux-persist';
import localForage from 'localforage';

import { isServer } from './utils';
import routesMap from './routesMap';
import options from './options';
import * as reducers from './reducers';
import appReducer, { appSettings, iconData } from './reducers/reducers';
import patterndesignapi from './middleware/patterndesign-api';
import favorites from './reducers/favorites';
import migrations from './reducers/migrations';

const configStore = (preLoadedState, initialEntries) => {
    const { reducer, middleware, enhancer, thunk } = connectRoutes(routesMap, {
        ...options,
        initialEntries,
    });

    var middlewares = [
        middleware,
        reduxThunk,
        patterndesignapi,
    ];

    const persistUserdata = {
        key: 'userdata',
        storage: localForage,
        version: 2,
        whitelist: ['userdata', 'favorites'],
        migrate: createMigrate(migrations, { debug: false }),
    };

    const rootReducer = combineReducers({
        stolo: persistReducer(persistUserdata, appReducer),
        icons: iconData,
        appSettings,
        ...reducers,
        location: reducer,
    });
    var middlewares = applyMiddleware(...middlewares);
    const enhancers = composeEnhancers(enhancer, middlewares);
    const store = createStore(
        rootReducer,
        preLoadedState,
        enhancers,
    );
    var persistor = {};
    if (!isServer) {
        persistor = persistStore(store, null, () => {
            thunk(store);
        });
    }

    if (module.hot && process.env.NODE_ENV === 'development') {
        module.hot.accept('./reducers/index', () => {
            const reducers = require('./reducers/index');
            const appReducer = require('./reducers/reducers');
            const rootReducer = combineReducers({
                stolo: appReducer,
                icons: iconData,
                appSettings,
                ...reducers,
                location: reducer,
            });
            store.replaceReducer(rootReducer);
        });
    }

    return { store, thunk, persistor };
};

export default configStore;

const composeEnhancers = (...args) =>
    typeof window !== 'undefined'
        ? composeWithDevTools(...args)
        : compose(...args);



// WEBPACK FOOTER //
// ./src/configureStore.js